var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowOrderBy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    width: 2.07616,
    height: 14,
    rx: 1,
    transform: "matrix(1 4.21079e-08 4.53759e-08 -1 6.22852 14)",
    fill: "#0583DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.77211 7.70711C1.36672 8.09763 0.709442 8.09763 0.304046 7.70711C-0.101349 7.31658 -0.101349 6.68342 0.304046 6.29289L6.53253 0.292895C6.92552 -0.0856841 7.55832 -0.0989297 7.96802 0.262848L14.1965 5.76285C14.6191 6.13604 14.6477 6.76861 14.2603 7.17573C13.8729 7.58285 13.2162 7.61035 12.7936 7.23716L7.29778 2.38414L1.77211 7.70711Z",
    fill: "#0583DC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowOrderBy);
export default __webpack_public_path__ + "static/media/arrow-order-by.5f3b5a8351247a8a55f782eab337e7a7.svg";
export { ForwardRef as ReactComponent };